import { CHAINS } from 'consts';
import { devnetConfig } from 'consts/devnetConfig';
import { Address } from 'viem';

export const INITIAL_TOKENS = {
  [CHAINS.ethereum.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
  },
  [CHAINS.bsc.id]: {
    in: '0x0000000000000000000000000000000000000000', // BNB
    out: '0x55d398326f99059ff775485246999027b3197955', // USDT
  },
  [CHAINS.cronos.id]: {
    in: '0x0000000000000000000000000000000000000000', // CRO
    out: '0xc21223249ca28397b4b6541dffaecc539bff0c59', // USDC
  },
  [CHAINS.base.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913', // USDC
  },
  [CHAINS.linea.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0x176211869ca2b568f2a7d4ee941e073a821ee1ff', // USDC
  },
  [CHAINS.scroll.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0x06efdbff2a14a7c8e15944d1f4a48f9f95f663a4', // USDC
  },
  [CHAINS.manta.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0xb73603c5d87fa094b7314c74ace2e64d165016fb', // USDC
  },
  [CHAINS.blast.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0x4300000000000000000000000000000000000003', // USDB
  },
  [CHAINS.metis.id]: {
    in: '0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000', // METIS
    out: '0xea32a96608495e54156ae48931a7c20f0dcc1a21', // m.USDC
  },
  [CHAINS.xLayer.id]: {
    in: '0x0000000000000000000000000000000000000000', // OKB
    out: '0x1e4a5963abfd975d8c9021ce480b42188849d41d', // USDT
  },
  [CHAINS.arbitrum.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9', // USDT
  },
  [CHAINS.zetachain.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0x7c8dda80bbbe1254a7aacf3219ebe1481c6e01d7', // USDT.ETH
  },
  [CHAINS.polygon.id]: {
    in: '0x0000000000000000000000000000000000000000', // MATIC
    out: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', // USDT
  },
  [CHAINS.soneium.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: '0xba9986d2381edf1da03b0b9c1f8b00dc4aacc369', // USDC.e
  },
  [CHAINS.unit0.id]: {
    in: '0x0000000000000000000000000000000000000000', // UNIT0
    out: '0xb303d80db8415fd1d3c9fed68a52eeac9a052671', // USDT
  },
  [CHAINS.hyper.id]: {
    in: '0x0000000000000000000000000000000000000000', // HYPE
    out: '0xb8ce59fc3717ada4c02eadf9682a9e934f625ebb', // USD₮0
  },
  [CHAINS.zeroG.id]: {
    in: '0x0000000000000000000000000000000000000000', // 0G
    out: '0x1f3aa82227281ca364bfb3d253b0f1af1da6473e', // USDC.e
  },
  [CHAINS.devnet.id]: {
    in: '0x0000000000000000000000000000000000000000', // ETH
    out: devnetConfig.tokens.USDC.toLowerCase() as Address,
  },
} as const;

export const INITIAL_SETTINGS = {
  slippage: 0.5,
  usePMM: true,
};
